import {
  getBackgroundImageUrl,
  getLottieFilesFromCdn,
} from '@utils/nutrition/getImageUrl';
import GutDysbiosis from '@/assets/dysbiosis_gut.json';
import OralDysbiosis from '@/assets/dysbiosis_oral.json';
import GutMicrobiome from '@/assets/microbiome_gut.json';
import OralMicrobiome from '@/assets/microbiome_oral.json';
import InflammaginYellow from '@/assets/inflammaging_yellow.json';
import InflammagingRed from '@/assets/inflammaging_red.json';
import InflammagingGreen from '@/assets/inflammaging_green.json';
import BioAgeYellow from '@/assets/bio_age_yellow.json';
import BioAgeRed from '@/assets/bio_age_red.json';
import BioAgeGreen from '@/assets/bio_age_green.json';

// export const getBioAgeAnimation = (
//   biological_age: number,
//   actual_age: number,
// ): any => {
//   if (actual_age === biological_age) {
//     return getLottieFilesFromCdn('bio_age_yellow.json');
//   } else if (actual_age > biological_age) {
//     return getLottieFilesFromCdn('bio_age_green.json');
//   } else if (actual_age < biological_age) {
//     return getLottieFilesFromCdn('bio_age_red.json');
//   }
//   return getLottieFilesFromCdn('bio_age_green.json');
// };
//
// export const getImflammingAnimation = (message: string): any => {
//   const ranking = message.toLocaleLowerCase();
//   if (ranking === 'medium') {
//     return getLottieFilesFromCdn('inflammaging_yellow.json');
//   } else if (ranking === 'low') {
//     return getLottieFilesFromCdn('inflammaging_green.json');
//   } else if (ranking === 'high') {
//     return getLottieFilesFromCdn('inflammaging_red.json');
//   }
//   return getLottieFilesFromCdn('inflammaging_green.json');
// };

// biological_age <= 0 (e.g. 0, -1 for minor kits) means BA not applicable.
export const isBioAgeScoreHidden = (
  bioAgeScore: number | undefined,
): boolean => bioAgeScore === undefined || bioAgeScore <= 0;

export const getBioAgeOverlayImage = (
  biological_age: number,
  actual_age: number,
): string => {
  if (actual_age === biological_age) {
    return getBackgroundImageUrl('meduim_dial.png');
  } else if (actual_age > biological_age) {
    return getBackgroundImageUrl('low_dial.png');
  } else if (actual_age < biological_age) {
    return getBackgroundImageUrl('high_dial.png');
  }
  return getBackgroundImageUrl('meduim_dial.png');
};

export const getImflammingOverlayImage = (message: string): any => {
  const ranking = message.toLocaleLowerCase();
  if (ranking === 'medium') {
    return getBackgroundImageUrl('meduim_dial.png');
  } else if (ranking === 'low') {
    return getBackgroundImageUrl('low_dial.png');
  } else if (ranking === 'high') {
    return getBackgroundImageUrl('high_dial.png');
  }
  return getBackgroundImageUrl('meduim_dial.png');
};

export const getRichnessAnimation = (type: string): any => {
  if (type === 'gut') {
    return getLottieFilesFromCdn('micro_profile_gut.json');
  }
  return getLottieFilesFromCdn('micro_profile_oral.json');
};

export const getFallBackVdoRichnessAnimation = (type: string): any => {
  if (type === 'gut') {
    return GutMicrobiome;
  }
  return OralMicrobiome;
};

export const getDysbiosisAnimation = (type: string): any => {
  if (type === 'gut') {
    return getLottieFilesFromCdn('dysbiosis_gut.json');
  }
  return getLottieFilesFromCdn('dysbiosis_oral.json');
};

export const getFallBackVdoDysbiosisAnimation = (type: string): any => {
  if (type === 'gut') {
    return GutDysbiosis;
  }
  return OralDysbiosis;
};

export const getImflammingAnimationFromLocal = (message: string): any => {
  const ranking = message.toLocaleLowerCase();
  if (ranking === 'medium') {
    return InflammaginYellow;
  } else if (ranking === 'low') {
    return InflammagingGreen;
  } else if (ranking === 'high') {
    return InflammagingRed;
  }
  return InflammagingGreen;
};

export const getBioAgeAnimationFromLocal = (
  biological_age: number,
  actual_age: number,
): any => {
  if (actual_age === biological_age) {
    return BioAgeYellow;
  } else if (actual_age > biological_age) {
    return BioAgeGreen;
  } else if (actual_age < biological_age) {
    return BioAgeRed;
  }
  return BioAgeGreen;
};
